import { type ReactNode } from "react";

export const PageContainer = ({ children }: { children: ReactNode }) => (
  <div className="mx-auto w-full max-w-6xl space-y-6 px-4 py-6 lg:px-8">
    {children}
  </div>
);
